<section class="barcode-dialog">
  <!-- dialog header -->
  <div class="barcode-dialog__header">
    <h4 class="barcode-dialog__title">{{ title | translate }}</h4>
    <button (click)="close()">
      <i class="iconsax barcode-dialog__icon" icon-name="x"></i>
    </button>
  </div>

  <!-- qr code -->
  <div class="barcode-dialog__barcode-container">
    <qrcode
      cssClass="w-180 [&>canvas]:!w-180 [&>canvas]:!h-180"
      [qrdata]="barcodeContent"
      [margin]="4"
      [scale]="1"
      [title]="outputPngName"
      [width]="180"
      [errorCorrectionLevel]="'M'"
      (qrCodeURL)="onChangeQrCode($event)"></qrcode>
  </div>

  <!-- qr code options -->
  <div class="barcode-dialog__options">
    <!-- link preview input -->
    <pwj-input
      class="barcode-dialog__input"
      [inputValue]="barcodeContent"
      [isReadOnly]="true"></pwj-input>

    <!-- copy link button -->
    <button (click)="onCopyProductLink(barcodeContent)" class="options-link">
      <i class="iconsax options-link__icon" icon-name="notes-1"></i>
    </button>

    <!-- download button -->
    <button>
      <a
        class="options-download"
        [href]="qrCodeLink"
        [attr.download]="outputPngName">
        <i class="iconsax options-download__icon" icon-name="download-1"></i>
      </a>
    </button>
  </div>
</section>
